// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3nNMt","title":"Info_title__FRX0k","links":"Info_links__2PBAm","link":"Info_link__iwDae","logo":"Info_logo__1nKXX"};